import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import {Container,Row,Col,Button} from 'reactstrap';

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  {
    return (
      <div>
        <div>
          <Container className="pt-5">
            <Row className="pb-5">
              <Col className="text-center">                
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
              </Col>              
            </Row>
            <Row className="pb-5">
              <Col className="text-center text-white">                
                  <h2 className="">常見問題</h2>
                  <p>無論你是創作新手，講故達人，還是全職寫手，我們都歡迎你創製「人人故事」，將自己的故事發揚光大。</p>
              </Col>              
            </Row>
          </Container>
        </div>
        <div className="bg-light" style={{minHeight:`35px`} }>
          <Container>
            <Row className="pt-5 pb-5 container">
            


            
            <h2>Q1：「人人故事」有甚麼特色？</h2>
            <p>A：tbc...有別一般小說平台，讓創作人突破文字界邊，以互動形式說故事，讓讀者一按一按翻開你的小宇宙。創作人可以透過「人人故事」編輯器，上載及製作多媒體原創故事。</p>
            
            <p>編輯器介面親切及舒適方便，你可以用文字、顏色、圖像、影像、對話框、背景圖來調校故事的節奏和氣氛，輕鬆建立出獨一無二的故事世界觀。</p>
            
            <h2>Q2：參與「人人故事」有條件嗎？</h2>
            <p>A：你只需下載tbc app，以流動電話號碼或Facebook帳戶，免費登記成為tbc...會員，即可登入「人人故事」上載你的作品。</p>
            
            <p>一部電腦，一部手機，一個腦袋，無需審核，你就可以創作及分享「人人故事」。</p>
            
            <h2>Q3：如何於tbc...撰寫及發布「人人故事 」 ? 會經過審閱後才推出嗎？</h2>
            <p>A：會員登入帳戶後，即可使用編輯器撰寫及發布「人人故事」。 詳情請參閱「使用教學」。由於「人人故事」為開放平台，只要用戶遵守「條款及細則」，所發布的故事都會盡快公開與其他用戶分享。一發現上載故事有違規或侵犯他人版權，將會被即時下架。</p>
            
            <h2>Q4：「人人故事」編輯器會否自動儲存及儲存故事複本？</h2>
            <p>A：「人人故事」編輯器及伺服器只會儲存你的故事完成品。</p>
            
            <p>你把作品發佈後，系統會自動將JSON檔下載到你的電腦，以保存你的多媒體工作記錄。</p>
            
            <p>如果你想在編輯器修改故事，你必需再次上載JASON檔。否則，你將需要重新上載故事的文字檔，重新製作「人人故事」。</p>
            
            <p>所以，請務必自行管理及收藏故事的JSON檔和文字檔，以作日後修改、重新上載或保留作品之用。</p>
            
            <h2>Q5：我的「人人故事」為甚麼被下架了？</h2>
            <p>A：你的故事有可能與tbc...的條款及細則有所抵觸，詳情請參閱條款及細則內的 「關於上載內容」部分。</p>
            
            <h2>Q6：我的故事上載到tbc...後，我還擁有故事的版權嗎？</h2>
            <p>A：tbc...有機會聯絡會員洽購著作之版權，直至成功洽購之前，上載著作的會員會繼續持有版權，並同意tbc 流動應用程式及本網站享有刊載及處理所提交的著作的權利。</p>
            
            <h2 class="w-100">Q7：我會收到稿費嗎？</h2>
            <p>A：「人人故事」為公眾平台，因此不設投稿費，版權亦由作者繼續持有。</p>
            
            <h2>Q8：tbc...會為我的「人人故事」出書或被改編嗎？</h2>
            <p>A：tbc...會持續關注優秀的「人人故事」創作人，並有機會主動與創作人聯絡，進行故事討論，例如連繫外部實體出版社，陪伴創作人將作品從虛擬世界走進實體世界。出書之外，更有可能一起將作品延伸至舞台劇、電視劇、電影、遊戲等等。唯進行任何改編之前，都必定先與故事原作者進行商討及取得相關授權。</p>
            
                
            </Row>
          </Container>

        </div>
      </div>
    )
  }
}